import { AccessLimitationConfigDTO } from "./AccessLimitationConfigDTO";
import { DefaultLoginOptions } from "./DefaultLoginOptions";
import { SSOSettings } from "./SSOSettings";

export class LoginSettings {
    defaultLoginOptions = new DefaultLoginOptions();
    ssoSettings: SSOSettings[] = [];
    ssoCustomToken: string;
    accessLimitationConfig = new AccessLimitationConfigDTO();

    constructor(data?: Partial<AccessLimitationConfigDTO>) {
        Object.assign(this, data);
    }
}
